/**
 * Lightweight analytics wrapper that dispatches to both Google Analytics
 * (gtag) and Meta Pixel (fbq) — mirroring the original @kit/analytics
 * AnalyticsManager which broadcast every trackEvent to all providers.
 *
 * Safe to call before either script loads; both GAnalyticsScript and
 * MetaPixelScript set up stubs that queue calls until the real SDK arrives.
 */
export function trackEvent(
  eventName: string,
  eventProperties?: Record<string, string | string[]>,
) {
  if (typeof window === 'undefined') return;

  // Google Analytics
  if (typeof window.gtag === 'function') {
    window.gtag('event', eventName, eventProperties);
  }

  // Meta Pixel
  if (typeof window.fbq === 'function') {
    window.fbq('trackCustom', eventName, eventProperties);
  }
}

export function trackPageView(path: string) {
  if (typeof window === 'undefined') return;

  // Google Analytics
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'page_view', { page_path: path });
  }

  // Meta Pixel
  if (typeof window.fbq === 'function') {
    window.fbq('track', 'PageView');
  }
}
